import React from "react";
import { decodeHtmlElements } from "./common/helpers.js";
const OrganizerDetails = ({
  organizer: {
    name,
    friendlyName,
    address,
    city,
    postalCode,
    phone,
    fiscalCode,
    fiscalOffice,
    email,
  },
}) => (
  <>
    {friendlyName && (
      <div
        className="r_organizerName"
        style={{ fontWeight: 600, marginBottom: 0 }}
      >
        {friendlyName}
      </div>
    )}
    <div
      className="r_organizerName"
      style={{ fontSize: friendlyName ? 16 : 18 }}
    >
      {decodeHtmlElements(name)}
    </div>
    <div className="r_organizerDetailsMultiple">
      <div className="r_organizerMultipleRow">
        <div className="r_organizerColumnItem">
          <div className="r_organizerColumnItemTitle">
            {playdetailsv2_resources.producer_txtAddressText}
          </div>
          <div className="r_organizerColumnItemContent">{`${address}, ${city} ${postalCode}`}</div>
        </div>
        <div className="r_organizerColumnItem">
          <div className="r_organizerColumnItemTitle">
            {playdetailsv2_resources.Tel}
          </div>
          {phone && phone.trim() !== "-" ? (
            <a
              className="r_organizerColumnItemContent contentLink"
              href={`tel:${phone}`}
            >
              {phone}
            </a>
          ) : (
            <div className="r_organizerColumnItemContent">-</div>
          )}
        </div>
      </div>
      <div className="r_organizerMultipleRow">
        <div className="r_organizerColumnItem">
          <div className="r_organizerColumnItemTitle">
            {playdetailsv2_resources.TaxId}
          </div>
          <div className="r_organizerColumnItemContent">
            {fiscalCode || "-"}
          </div>
        </div>
        <div className="r_organizerColumnItem">
          <div className="r_organizerColumnItemTitle">
            {playdetailsv2_resources.TaxOffice}
          </div>
          <div className="r_organizerColumnItemContent">
            {fiscalOffice || "-"}
          </div>
        </div>
      </div>
      <div className="r_organizerMultipleRow">
        <div className="r_organizerColumnItem">
          <div className="r_organizerColumnItemTitle">
            {playdetailsv2_resources.Email}
          </div>
          {email && email.trim() !== "-" ? (
            <a
              className="r_organizerColumnItemContent contentLink"
              href={`mailto:${email}`}
            >
              {email}
            </a>
          ) : (
            <div className="r_organizerColumnItemContent">-</div>
          )}
        </div>
      </div>
    </div>
  </>
);

export default OrganizerDetails;
